import type { BinaryFeatureCollection } from "@loaders.gl/schema";
import { CustomPMTilesMVTLayer } from "common/functions/classes/CustomPMTilesMVTLayer";
import { TileLoadProps } from "common/types/TileLoadProps";

export class MojMVTPolygonLayer<
  ExtraProps extends object
> extends CustomPMTilesMVTLayer<ExtraProps> {
  getPMTilesPath(z: number): string {
    if (z >= 1 && z <= 5) return "json/moj/tiles/z01-05.pmtiles";
    if (z >= 6 && z <= 9) return "json/moj/tiles/z06-09.pmtiles";
    if (z >= 10 && z <= 12) return "json/moj/tiles/z10-12.pmtiles";
    if (z >= 13 && z <= 15) return "json/moj/tiles/z13-15.pmtiles";
    if (z >= 16 && z <= 18) return "json/moj/tiles/z16-18.pmtiles";
    if (z >= 19) return "json/moj/tiles/z19-20.pmtiles";
    return "json/moj/tiles/z01-05.pmtiles";
  }

  async getTileData(
    loadProps: TileLoadProps
  ): Promise<BinaryFeatureCollection> {
    const data = await super.getTileData(loadProps);

    if (loadProps.index.z < 19) {
      const lines = data.lines;

      if (lines) {
        data.lines = {
          ...lines,
          positions: { value: new Float32Array(0), size: lines.positions.size },
          pathIndices: { value: new Uint32Array([0]), size: 1 },
          properties: []
        };
      }

      const points = data.points;

      if (points) {
        data.points = {
          ...points,
          positions: {
            value: new Float32Array(0),
            size: points.positions.size
          },
          properties: []
        };
      }
    }

    return data;
  }

  renderSubLayers(props: any) {
    const z = props.tile.index.z;
    const next = { ...props };

    if (z < 19) {
      next.stroked = false;
      next.pointType = "";
    }

    return super.renderSubLayers(next);
  }
}
